module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/03-4b7160d6339becb0e931a1d9cebdbb72.png";